module.exports = __webpack_public_path__ + "img/8.35167db0.jpg";